module.exports = __webpack_public_path__ + "static/img/PL.9c51b410.png";